import { useId, useToastController } from "@fluentui/react-components";
import { useCallback } from "react";

import { ToastWithoutAction } from "../components/ui/common/toast-without-action.js";

interface ToastOptions {
  title?: string;
  message: string;
}

export const useToast = () => {
  const toasterId = useId("toaster");

  const { dispatchToast } = useToastController(toasterId);

  const dispatchSuccessToast = useCallback(
    ({ title = "Success", message }: ToastOptions) => {
      dispatchToast(<ToastWithoutAction message={message} title={title} />, {
        intent: "success",
      });
    },
    [dispatchToast]
  );

  const dispatchFailureToast = useCallback(
    ({ title = "Error", message }: ToastOptions) => {
      dispatchToast(<ToastWithoutAction message={message} title={title} />, {
        intent: "error",
      });
    },
    [dispatchToast]
  );

  const dispatchWarningToast = useCallback(
    ({ title = "Warning", message }: ToastOptions) => {
      dispatchToast(<ToastWithoutAction message={message} title={title} />, {
        intent: "warning",
      });
    },
    [dispatchToast]
  );

  return {
    dispatchFailureToast,
    dispatchSuccessToast,
    dispatchWarningToast,
    toasterId,
  };
};
